import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="rk-footer">
      <div className="footer-grid">
        {/* Brand */}
        <div>
          <Link to="/" className="rk-logo" style={{ marginBottom: 0 }}>
            <div className="rk-logo-icon">
              <i className="bi bi-shield-fill"></i>
            </div>
            <div>
              <span className="rk-logo-text">RAKSHA</span>
              <span className="rk-logo-sub">Ireland</span>
            </div>
          </Link>
          <p className="footer-brand-tagline">
            Community-powered personal safety network. Bridging the gap when every second counts.
          </p>
          <div className="footer-socials">
            <a href="https://twitter.com/" target="_blank" rel="noreferrer" className="footer-social">
              <i className="bi bi-twitter-x"></i>
            </a>
            <a href="https://instagram.com/" target="_blank" rel="noreferrer" className="footer-social">
              <i className="bi bi-instagram"></i>
            </a>
            <a href="mailto:support@rakshaireland.ie" className="footer-social">
              <i className="bi bi-envelope"></i>
            </a>
          </div>
        </div>

        {/* The App */}
        <div>
          <p className="footer-col-title">The App</p>
          <div className="footer-col-links">
            <a href="#download">Download</a>
            <Link to="/features">Features</Link>
            <Link to="/how-it-works">How It Works</Link>
          </div>
        </div>

        {/* Legal */}
        <div>
          <p className="footer-col-title">Legal &amp; Info</p>
          <div className="footer-col-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/privacy-policy">Terms of Use</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>

        {/* Contact */}
        <div>
          <p className="footer-col-title">Get in Touch</p>
          <div className="footer-contact-row">
            <i className="bi bi-envelope-fill"></i>
            <a href="mailto:support@rakshaireland.ie">support@rakshaireland.ie</a>
          </div>
          <div className="footer-contact-row">
            <i className="bi bi-geo-alt-fill"></i>
            <span>Dublin, Ireland<br /><span style={{ fontSize: '0.8rem', opacity: 0.6 }}>Serving all of Ireland</span></span>
          </div>
          <div className="footer-contact-row" style={{ marginTop: 8 }}>
            <i className="bi bi-clock-fill"></i>
            <span>Admin team active 24/7</span>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © 2026 RAKSHA Ireland. All rights reserved. RAKSHA is a community-powered personal safety network.
      </div>
    </footer>
  );
}
